import React from "react"

import PropTypes from "prop-types"

import * as styles from "./loader.module.scss"
import Icon from "../icon"

const Loader = ({ absolute }) => (
  <div
    className={`${styles.loader} ${absolute ? styles.loader__absolute : ""}`}
  >
    <div>
      <Icon icon="autorenew" spin />
    </div>
  </div>
)

export default Loader

Loader.propTypes = {
  absolute: PropTypes.bool,
}

Loader.defaultProps = {
  absolute: false,
}
